import type { GameContext, GameMiddleware } from "./types";

/**
 * Calls THREE.AnimationHandler.update(delta) each frame.
 * Active in preview / client mode, paused in editor mode.
 */
export class AnimationMiddleware implements GameMiddleware {
    // Default true so the client (which never calls onModeChange) is always active.
    // The Editor calls onModeChange("editor") right after init to deactivate it.
    private _active = true;

    init(_ctx: GameContext): void {}

    update(delta: number): void {
        if (!this._active) return;
        if ((window as any).THREE?.AnimationHandler) {
            (window as any).THREE.AnimationHandler.update(delta);
        }
    }

    onModeChange(mode: "editor" | "preview"): void {
        this._active = mode === "preview";
    }
}
